/**
 * Convert camelCase to dash-case properties.
 */var camelToDash=function camelToDash(str){return str.replace(/([a-z])([A-Z])/g,"$1-$2").toLowerCase();};export{camelToDash};